import { render, staticRenderFns } from "./GenerateIMOCrewList.vue?vue&type=template&id=060bb814&scoped=true&"
import script from "./GenerateIMOCrewList.vue?vue&type=script&lang=js&"
export * from "./GenerateIMOCrewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060bb814",
  null
  
)

export default component.exports